import { useState } from "react";
import { toast } from "sonner";
import { Send, Loader2 } from "lucide-react";
import { useApi, errMsg } from "@/lib/api";

export const AnalystChat = ({ m, r, messages, setMessages }) => {
  const api = useApi();
  const [text, setText] = useState("");
  const [busy, setBusy] = useState(false);
  const id = `${m.id}-${r.number}`;
  const send = async () => {
    const t = text.trim();
    if (!t || busy) return;
    setBusy(true);
    setMessages((x) => [...x, { role: "user", text: t, pending: true }]);
    setText("");
    try {
      setMessages((await api("post", `/analyst/races/${m.id}/${r.number}/chat`, { text: t })).messages);
    } catch (e) {
      toast.error(errMsg(e));
      setMessages((x) => x.filter((y) => !y.pending));
      setText(t);
    }
    setBusy(false);
  };
  const clear = async () => {
    try { await api("delete", `/analyst/races/${m.id}/${r.number}/chat`); setMessages([]); } catch (e) { toast.error(errMsg(e)); }
  };
  return (
    <div className="space-y-2" data-testid={`analyst-chat-${id}`}>
      <div className="max-h-80 overflow-y-auto space-y-2 pr-1" data-testid={`analyst-messages-${id}`}>
        {!messages.length && <p className="text-xs text-slate-500">Ask why it picked a horse, challenge its reasoning or point out what it missed.</p>}
        {messages.map((x, i) => (
          <div key={i} className={`rounded-xl px-3 py-2 text-sm whitespace-pre-wrap ${x.role === "user" ? "bg-blue-600/20 border border-blue-500/30 ml-6" : "bg-[#0B101D] border border-white/5 mr-6 text-slate-200"}`} data-testid={`analyst-msg-${id}-${i}`}>{x.text}</div>
        ))}
        {busy && <p className="flex items-center gap-1.5 text-xs text-slate-400"><Loader2 className="w-3.5 h-3.5 animate-spin" />Analyst is thinking…</p>}
      </div>
      <div className="flex gap-2">
        <textarea data-testid={`analyst-input-${id}`} value={text} onChange={(e) => setText(e.target.value)} onKeyDown={(e) => { if (e.key === "Enter" && !e.shiftKey) { e.preventDefault(); send(); } }}
          rows={2} maxLength={2000} placeholder="e.g. Why Duomo over Gaultier on a Heavy 9?" className="flex-1 bg-[#0B101D] border border-white/10 rounded-xl p-2 text-sm focus:border-blue-500 outline-none" />
        <button data-testid={`analyst-send-${id}`} onClick={send} disabled={busy || !text.trim()} aria-label="Send" className="self-end p-2.5 rounded-full bg-blue-600 hover:bg-blue-500 disabled:opacity-40"><Send className="w-4 h-4" /></button>
      </div>
      {messages.length > 0 && <button data-testid={`analyst-clear-${id}`} onClick={clear} className="text-[11px] text-slate-500 hover:text-slate-300">Clear conversation</button>}
    </div>
  );
};
